import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(theme => ({
  button: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
  icon: {
    display: 'flex',
    alignItems: 'center',
    width: 28,

    '& > img': {
      width: '100%',
    },
  },
}));
